import { backendHost } from "../config";

export const urls = {
    POST_AUTHORIZATION: `${backendHost}/api/admin/auth/authorization`,
    POST_AUTHORIZATION_ROOT: `${backendHost}/api/admin/auth/authorization/root`,
    GET_AUTHORIZE: `${backendHost}/api/admin/auth`,
    GET_AUTHORIZE_ROOT: `${backendHost}/api/admin/auth/root`,
    GET_LIST_JACKPOT: `${backendHost}/api/admin/jackpot/list`,
    GET_LIST_ADMIN: `${backendHost}/api/admin/admin/list`,
    GET_LIST_EVENT: `${backendHost}/api/admin/admin/events/list`,
    GET_HISTORY_LIST: `${backendHost}/api/admin/admin/history/list`,
    GET_LIST_HISTORY: `${backendHost}/api/admin/history/list`,
    GET_ALLOWS_ADMIN: `${backendHost}/api/admin/allows`,
    POST_ADMIN_VIEW_UPDATE: `${backendHost}/api/admin/allows`,
    GET_LIST_HISTORY_BONUSES: `${backendHost}/api/admin/bonuses/history/list`,
    GET_PERSONAL_LIST_BONUSES: `${backendHost}/api/admin/bonuses/list/personal`,
    POST_ISSUE_PERSONAL_BONUSES: `${backendHost}/api/admin/bonuses/personal/issue`,
    GET_BONUSES_LIST: `${backendHost}/api/admin/bonuses/list`,
    GET_VIEW_BONUSES: `${backendHost}/api/admin/bonuses/view`,
    POST_CREATE_BONUSES: `${backendHost}/api/admin/bonuses/create`,
    GET_BETS_FREESPIN: `${backendHost}/api/admin/freespin/bets`,
    POST_BETS_FREESPIN: `${backendHost}/api/admin/freespin/bets`,
    GET_UPDATE_BONUSES: `${backendHost}/api/admin/bonuses/update`,
    GET_LIST_SHIFT_CASHIERS: `${backendHost}/api/admin/cashiers/shift/list`,
    GET_GROUPS_CASHIERS: `${backendHost}/api/admin/cashiers/groups`,
    POST_GROUPS_CASHIERS: `${backendHost}/api/admin/cashiers/groups`,
    GET_USERS_CASHIERS: `${backendHost}/api/admin/cashiers/users`,
    POST_USERS_CASHIERS: `${backendHost}/api/admin/cashiers/users`,
    POST_BLOCK_CASHIERS: `${backendHost}/api/admin/cashiers/block`,
    GET_LIST_HISTORY_CASHIER: `${backendHost}/api/admin/cashier/history/list/`,
    POST_CHANGE_LETTER_CASHIERS: `${backendHost}/api/admin/cashiers/change-letter`,
    POST_CHANGE_PASSWORD_CASHIERS: `${backendHost}/api/admin/cashiers/change-password`,
    POST_HIDE_CASHIERS: `${backendHost}/api/admin/cashiers/hide`,
    GET_VIEW_CASHIERS: `${backendHost}/api/admin/cashiers/view`,
    POST_CASHIER_WAGER: `${backendHost}/api/admin/wager/cashier`,
    GET_LIMITS_GAMES: `${backendHost}/api/admin/games/limits`,
    GET_LIVE_LIMITS: `${backendHost}/api/admin/limits/live`,
    POST_EXCHANGE_RATES: `${backendHost}/api/admin/exchange-rates`,
    PUT_EXCHANGE_RATES_LIST: `${backendHost}/api/admin/exchange-rates`,
    GET_EXCHANGE_RATES: (id) => `${backendHost}/api/admin/exchange-rates/${id}`,
    GET_FREESPIN: `${backendHost}/api/admin/freespin`,
    GET_LIST_FREESPIN: `${backendHost}/api/admin/freespin/list`,
    GET_ISSUE_FREESPIN: `${backendHost}/api/admin/freespin/issue`,
    GET_LIST_GAME_FS: `${backendHost}/api/admin/fs-game/list`,
    GET_VIEW_GAME_FS: `${backendHost}/api/admin/fs-game/view`,
    POST_ADD_GAME_FS: `${backendHost}/api/admin/fs-game/add`,
    POST_DETAIL_UPDATE_GAME_FS: `${backendHost}/api/admin/fs-game/detailUpdate`,
    POST_UPDATE_GAME_FS: `${backendHost}/api/admin/fs-game/update`,
    GET_REPORT_REPLENISHMENT: `${backendHost}/api/admin/replenishment/report`,
    GET_LIST_REPLENISHMENT: `${backendHost}/api/admin/replenishment/list`,
    GET_LIST_REPLENISHMENT_ID: (id) => `${backendHost}/api/admin/replenishment/list/${id}`,
    GET_LIST_REPLENISHMENT_HISTORY: `${backendHost}/api/admin/history-replenishment/list`,
    GET_COUNT_STATUS: `${backendHost}/api/admin/status/count`,
    GET_DETALIZATION_INFORMATION: `${backendHost}/api/admin/information/detalization`,
    GET_USERS_INFORMATION: `${backendHost}/api/admin/information/users`,
    GET_LIST_GROUP_JACKPOT: `${backendHost}/api/admin/jackpot/group/list`,
    GET_VIEW_JACKPOT: `${backendHost}/api/admin/jackpot/view`,
    POST_CREATE_JACKPOT: `${backendHost}/api/admin/jackpot/create`,
    POST_ISSUE_JACKPOT: `${backendHost}/api/admin/jackpot/issue`,
    POST_UPDATE_NULLIFY_JACKPOT: `${backendHost}/api/admin/jackpot/nullify/update`,
    POST_UPDATE_GIVE_JACKPOT: `${backendHost}/api/admin/jackpot/give/update`,
    POST_UPDATE_JACKPOT: `${backendHost}/api/admin/jackpot/update`,
    POST_UPDATE_VISIBLE_JACKPOT: `${backendHost}/api/admin/jackpot/visible/update`,
    GET_LIST_KYC: `${backendHost}/api/admin/kyc/list`,
    POST_UPDATE_KYC: `${backendHost}/api/admin/kyc/update`,
    GET_EDIT_LOTTERY: `${backendHost}/api/admin/lottery/edit`,
    GET_LIST_LOTTERY: `${backendHost}/api/admin/lottery/list`,
    GET_PRIZE_LOTTERY: `${backendHost}/api/admin/lottery/prize`,
    GET_STAT_LOTTERY: `${backendHost}/api/admin/lottery/stat`,
    GET_WINNERS_LOTTERY: `${backendHost}/api/admin/lottery/winners`,
    POST_CHECK_PRIZE_LOTTERY: `${backendHost}/api/admin/lottery/prize/check`,
    POST_CREATE_LOTTERY: `${backendHost}/api/admin/lottery/create`,
    POST_ISSUE_PRIZE_LOTTERY: `${backendHost}/api/admin/lottery/prize/issue`,
    POST_UPDATE_LOTTERY: `${backendHost}/api/admin/lottery/update`,
    GET_MESSANGER: `${backendHost}/api/admin/messanger`,
    GET_MESSANGER_VIEW: (id) => `${backendHost}/api/admin/messanger/${id}`,
    POST_MESSANGER: `${backendHost}/api/admin/messanger`,
    PUT_MESSANGER: `${backendHost}/api/admin/messanger`,
    GET_LIST_OBJECT: `${backendHost}/api/admin/object/list`,
    POST_CREATE_OBJECT: `${backendHost}/api/admin/object/create`,
    POST_UPDATE_OBJECT: `${backendHost}/api/admin/object/update`,
    GET_LIST_PAYMENT: `${backendHost}/api/admin/payment/list`,
    POST_CREATE_PAYMENT: `${backendHost}/api/admin/payment/create`,
    POST_UPDATE_PAYMENT: `${backendHost}/api/admin/payment/update`,
    GET_LIST_PRESENT: `${backendHost}/api/admin/present/list`,
    POST_CANCEL_PRESENT: `${backendHost}/api/admin/present/cancel`,
    POST_SUCCESS_PRESENT: `${backendHost}/api/admin/present/success`,
    GET_VIEW_KEYS: `${backendHost}/api/admin/keys/view`,
    POST_CREATE_KEYS: `${backendHost}/api/admin/keys/create`,
    GET_REFERRALS_BONUSES_REFERRALS: `${backendHost}/api/admin/referrals/bonuses/referrals`,
    GET_LIST_REFERRALS: `${backendHost}/api/admin/referrals/list`,
    GET_VIEW_REFERRALS: `${backendHost}/api/admin/referrals/view`,
    POST_CREATE_BONUSES_REFERRALS: `${backendHost}/api/admin/referrals/bonuses/create`,
    POST_ISSUE_BONUSES_REFERRALS: `${backendHost}/api/admin/referrals/bonuses/issue`,
    POST_PERCENT_UPDATE_REFERRALS: `${backendHost}/api/admin/referrals/update/percent`,
    GET_LIST_CATEGORIES: `${backendHost}/api/admin/categories/list`,
    GET_LIST_FINANCE_OPERATION: `${backendHost}/api/admin/finance-operation/list`,
    GET_VIEW_DAILY_SHIFT_CASHIERS: `${backendHost}/api/admin/cashiers/shift/daily/view`,
    GET_LOGIN_USER_CASHIERS: `${backendHost}/api/admin/cashiers/user/login`,
    GET_VIEW_GGR: `${backendHost}/api/admin/ggr/view`,
    GET_REPLENISHMENT_OPERATIONS_GGR: `${backendHost}/api/admin/ggr/operations/replenishment`,
    GET_WITHDRAWAL_OPERATIONS_GGR: `${backendHost}/api/admin/ggr/operations/withdrawal`,
    GET_LIST_BET: `${backendHost}/api/admin/bet/list`,
    GET_LIST_HISTORY_REPLENISHMENT: `${backendHost}/api/admin/history-replenishment/list`,
    GET_INFORMATION_GAMER: `${backendHost}/api/admin/gamer/information`,
    GET_LIST_GAMER: `${backendHost}/api/admin/gamer/list`,
    GET_DETALIZATON_OPERATOR: `${backendHost}/api/admin/operator/detalizaton`,
    GET_VIEW_GROUPS_CASHIERS: `${backendHost}/api/admin/cashiers/groups/view`,
    POST_BALANCE_GROUPS_CASHIERS: `${backendHost}/api/admin/cashiers/groups/balance`,
    GET_LIST_HISTORY_JACKPOT: `${backendHost}/api/admin/jackpot/history/list`,
    GET_LIST_REPORT_GAMES: `${backendHost}/api/admin/report-games/list`,
    GET_SEARCH_REPORT_GAMES: `${backendHost}/api/admin/report-games/search`,
    GET_LIST_GAMES: `${backendHost}/api/admin/games/list`,
    GET_LIST_LIVE_GAMES: `${backendHost}/api/admin/games/live/list/`,
    GET_STATUS_UPDATE: `${backendHost}/api/admin/update/status`,
    POST__STATUS_UPDATE: `${backendHost}/api/admin/update/status`,
    GET_LIST_AWAITING_WITHDRAWAL: `${backendHost}/api/admin/withdrawal/awaiting/list`,
    POST_STATUS_UPDATE_WITHDRAWAL: `${backendHost}/api/admin/withdrawal/update/status`,
    GET_LIST_USERS: `${backendHost}/api/admin/v2/users/list`,
    GET_LIST_SUPPORT: `${backendHost}/api/admin/support/list`,
    GET_VIEW_SUPPORT: `${backendHost}/api/admin/support/view`,
    POST_UPDATE_STATUS_SUPPORT: `${backendHost}/api/admin/support/status/update`,
    GET_LIST_TOURNAMENT: `${backendHost}/api/admin/tournament/list`,
    GET_SEARCH_GAMES: `${backendHost}/api/admin/games/search`,
    GET_VIEW_TOURNAMENT: `${backendHost}/api/admin/tournament/view`,
    GET_VIEW_TOURNAMENT_STAT: `${backendHost}/api/admin/tournament-stat/view`,
    POST_CREATE_TOURNAMENT: `${backendHost}/api/admin/tournament/create`,
    POST_USER_CREATE_TOURNAMENT: `${backendHost}/api/admin/tournament/create/user`,
    POST_ISSUE_TOURNAMENT: `${backendHost}/api/admin/tournament/issue`,
    POST_POINTS_UPDATE_TOURNAMENT: `${backendHost}/api/admin/tournament/update/points`,
    POST_UPDATE_TOURNAMENT: `${backendHost}/api/admin/tournament/update`,
    GET_LIST_VERIFICATIONS: (id) => `${backendHost}/api/admin/verifications/list/${id}`,
    GET_LIST_ID_FREESPIN: `${backendHost}/api/admin/freespin/list_id`,
    GET_STATUS_LIST_FS_GAME: `${backendHost}/api/admin/fs-game/list/status`,
    GET_USER_HISTORY_BONUSES: `${backendHost}/api/admin/bonuses/history/user`,
    GET_LIST_HISTORY_ID: (id) => `${backendHost}/api/admin/history/list/${id}`,
    GET_LIST_ID_REPORT_GAMES: `${backendHost}/api/admin/report-games/list_id`,
    GET_GROUP_REPORT_GAMES: `${backendHost}/api/admin/report-games/group`,
    GET_USER: (id) => `${backendHost}/api/admin/user/${id}`,
    GET_VIEW_USER_LOGGER: `${backendHost}/api/admin/user-logger/view`,
    GET_LIST_WITHDRAWAL: `${backendHost}/api/admin/withdrawal/list`,
    GET_LIST_WITHDRAWAL_ID: (id) => `${backendHost}/api/admin/withdrawal/list/${id}`,
    POST_AIR_BALANCE_USER: `${backendHost}/api/admin/user/balance/air`,
    POST_USER_BLOCK: `${backendHost}/api/admin/block_user`,
    POST_COPY_REPLENISHMENT: `${backendHost}/api/admin/replenishment/copy`,
    POST_COPY_WAGER: `${backendHost}/api/admin/wager/copy`,
    POST_CREATE_FS: `${backendHost}/api/admin/fs/create`,
    POST_ISSUE_LIFTING: `${backendHost}/api/admin/lifting/issue`,
    POST_SIGNUSER: `${backendHost}/api/admin/signuser`,
    POST_BALANCE: `${backendHost}/api/admin/balance`,
    POST_WAGER: `${backendHost}/api/admin/wager`,
    POST_CHANGE_PASSWORD: `${backendHost}/api/admin/change-password`,
    GET_GROUP_JACKPOT: `${backendHost}/api/admin/jackpot/group`,
    POST_WAGERPAY: `${backendHost}/api/admin/user/wager-pay`,
    POST_WAGERFRESSPIN: `${backendHost}/api/admin/user/wager-freespin`,
    PINSALE: `${backendHost}/api/admin/pinsale`,
}